import {Http, Response, RequestOptions} from "@angular/http";
import {UtilService} from "../util";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import {ServiceLocatorService} from "./service-locator.service";

export abstract class RestApiService {
  URL: string = "/location";
  private http: Http;
  private utilService: UtilService;

  public ServiceLocatorService = ServiceLocatorService;

  constructor() {
  }

  /**
   * Dependency Injector
   */
  init() {
    this.http = this.http || this.ServiceLocatorService.injector.get(Http);
    this.utilService = this.utilService || this.ServiceLocatorService.injector.get(UtilService);
  }

  protected add<T>(url: string, body: T): Observable<T> {
    this.init();
    return this.http
      .post(url, body)
      .map((res: Response) => {
        return this.utilService.outputParser(res);
      })
      .catch(this.utilService.handleError);
  }

  protected get<T>(url: string, searchCriteria?: SearchCriteria): Observable<T> {
    this.init();
    let queryParams = null;

    if (searchCriteria) {
      queryParams = this.utilService.setQueryParams({
        page: searchCriteria.PageNumber,
        sort: searchCriteria.Sort,
        order: searchCriteria.Order,
        search: searchCriteria.SearchTerm
      });
    }

    let options = new RequestOptions({params: queryParams});
    return this.http
      .get(url, options)
      .map((res: Response) => {
        return this.utilService.outputParser(res);
      })
      .catch(this.utilService.handleError);
  }

  protected patch() {

  }

  protected update() {

  }

  protected remove(object: any) {
    this.init();
    return new Observable((observer) => {
      console.log("This object has been deleted ::: " + object);
      observer.next();
    });
  }
}




// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/base-api/rest-api.service.ts